import { useState } from 'react'
import { Modal as AntModal, Button, Upload } from 'antd'
import * as Icons from '@ant-design/icons'
import { uploadToSasLink } from 'admin/lib/Api/core'

import { useApi } from 'admin/lib/Api'

export function CompaniesImport() {
  const api = useApi()
  const [uploading, setUploading] = useState(false)

  async function handleUpload(fileList) {
    setUploading(true)
    const confirmation = await new Promise(resolve =>
      AntModal.confirm({
        title: 'Confirm Upload',
        content: (
          <>
            <p>Confirm Companies file for upload </p>
            <p>{fileList[0].name}</p>
          </>
        ),
        onOk: () => {
          resolve(true)
        },
        onCancel: () => {
          resolve(false)
        }
      })
    )

    if (!confirmation) {
      setUploading(false)
      return
    }

    const [sasURI, getUriStatus, getUriError] =
      await api.getUploadCompaniesLink()

    if (getUriError) {
      setUploading(false)
      AntModal.error({
        title: 'Error Generating Import link',
        content: (
          <>
            <p>Error, you may wish to try again. </p>
            <p>{`Details: ${getUriStatus}: ${getUriError}`}</p>
          </>
        )
      })
      return
    }

    const [, uploadStatus, uploadError] = await uploadToSasLink(
      sasURI,
      fileList[0]
    )

    if (uploadError) {
      setUploading(false)
      AntModal.error({
        title: 'Error Uploading Companies',
        content: (
          <>
            <p>Error, you may wish to try again. </p>
            <p>{`Details: ${uploadStatus}: ${uploadError}`}</p>
          </>
        )
      })
      return
    }

    const [, queueStatus, queueError] =
      await api.queueReferenceDataImport('companies')

    if (uploadError) {
      setUploading(false)
      AntModal.error({
        title: 'Error Queueing Import',
        content: (
          <>
            <p>Error, you may wish to try again. </p>
            <p>{`Details: ${queueStatus}: ${queueError}`}</p>
          </>
        )
      })
      return
    }

    setUploading(false)
    AntModal.success({
      title: 'Success! 💪😎🍹',
      content: 'Companies Imported. Values might take time to reflect  ',

      onOk: () => {
        setUploading(false)
      },
      onCancel: () => {
        setUploading(false)
      }
    })
  }

  return (
    <Upload
      accept=".csv"
      beforeUpload={file => {
        handleUpload([file])
        return false
      }}
      showUploadList={false}
    >
      <Button
        icon={<Icons.UploadOutlined />}
        disabled={uploading}
        type="default"
      >
        Import
      </Button>
    </Upload>
  )
}
